import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CandidateModel } from '../../models/candidate.model';
import { DataService } from '../../services/data.service';
import { AcModel } from '../../models/ac.model';
import { ExerciseModel } from '../../models/exercise.model';
import { TranslocoService } from '@ngneat/transloco';
import { GroupModel } from '../../models/group.model';
import { AuthStateService } from '../../services/auth-state.service';

class CandidateWithGroupModel {
  candidate: CandidateModel;
  groupName: string | null;
}

@Component({
  selector: 'app-candidate-selector',
  templateUrl: './candidate-selector.component.html',
  styleUrls: ['./candidate-selector.component.scss']
})
export class CandidateSelectorComponent implements OnInit {

  @Input() candidate: CandidateModel = null;
  @Input() exercise: ExerciseModel = null;
  @Input() group: GroupModel = null;
  @Output() candidateChange = new EventEmitter<CandidateModel>();

  public candidates: Array<CandidateWithGroupModel> = [];
  public visible = false;

  constructor(
    private data: DataService,
    public auth: AuthStateService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.data.ac$.subscribe((ac: AcModel) => {
      if (ac !== null) {
        this.visible = ac.isGroup() === true;
        const groups: any = this.data.getGroupsForExercise(this.exercise?.id) || null;
        if (groups !== null) {
          Object.keys(groups).forEach((key: string, index: number) => {
            if (!groups[key].name) {
              groups[key].name = this.transloco.translate('common.labels.group') + ' ' + (index + 1);
            }
          });
        }
        const me = ac.getUser(this.auth.getHashedId());
        this.candidates = ac.candidates.filter((candidate: CandidateModel) => {
          return (this.exercise?.isIndividual() && candidate.hashed_id === this.candidate.hashed_id) ||
            (!this.exercise?.isIndividual() && this.data.canIRateCandidate(this.exercise, candidate, this.group, me));
        }).map((candidate: CandidateModel) => {
          const custom: CandidateWithGroupModel = {
            candidate,
            groupName: null
          };
          if (this.exercise !== null) {
            const groupHash = this.data.getGroupForCandidate(this.exercise.id, candidate.hashed_id);
            custom.groupName = this.data.getGroupName(this.exercise.id, groupHash) || null;
            if (custom.groupName === null && groups !== null && groups[groupHash]) {
              custom.groupName = groups[groupHash].name;
            }
          }
          return custom;
        }) || [];
        if (this.candidate === null && this.candidates.length > 0) {
          this.onChangeCandidate(this.candidates[0]);
        }
      }
    });
  }

  onChangeCandidate(candidate: CandidateWithGroupModel): void {
    this.candidateChange.emit(candidate.candidate);
  }

}
